import React from "react";
import styles from "./Accounting.module.scss";
import primaryComponents from "../../../../components/primaryComponents";
import secondaryComponents from "../../../../components/secondaryComponents";
import { useNavigate } from "react-router-dom";
import useAccounting from "./useAccounting";
import { pathConstants } from "../../../../routes/pathContants";
import { ExclamationCirlce } from "../../../../assets/svgIcons";

const AccountingOverview = () => {
  const navigate = useNavigate();
  const { isLoading, data } = useAccounting();
  let labelTootipText =
    "From Wednesday 27th May 2026, new financial records will be captured in the new Accounting Module. Please use the Accounting Module for updated reports and export any historical data you may still need from this page.";
  const labelIcon = (
    <ExclamationCirlce width="18" height="18" stroke="#e02020" />
  );

  return (
    <secondaryComponents.LoaderHelper isLoading={isLoading} classNames="mt-5">
      <div className={styles.cards_container}>
        <div className={styles.card}>
          <div style={{ textAlign: "left" }}>
            <div className={styles.title}>
              <h6 className={"big-text-size"}> Profit And Loss </h6>
            </div>
            <span className={"smallest-text-size"}>
              Shows whether your business is making money or losing it by
              comparing income and expenses.
            </span>
            <div
              style={{ marginTop: "10px", width: "100%" }}
              className="error--squared"
            >
              <secondaryComponents.ToolTipV2 tipText={labelTootipText}>
                <span className="ml-2">{labelIcon}</span>
                Warning: This report is being deprecated
              </secondaryComponents.ToolTipV2>
            </div>
          </div>
          <primaryComponents.Button
            type="button"
            classNames={"btn btn--outline w-100"}
            onClick={() =>
              navigate(
                pathConstants.ACCOUNTING_DETAILS({ id: "profit-and-loss" }),
              )
            }
          >
            View Report
          </primaryComponents.Button>
        </div>
        <div className={styles.card}>
          <div style={{ textAlign: "left" }}>
            <div className={styles.title}>
              <h6 className={"big-text-size"}>VAT Ledger</h6>
            </div>
            <span className={"smallest-text-size"}>
              Provides a summary of the VAT collected and paid by your business,
              helping you keep track of your tax obligations.
            </span>
          </div>
          <primaryComponents.Button
            type="button"
            classNames={"btn btn--outline w-100"}
            onClick={() => navigate(pathConstants.ACCOUNTING_VAT_LEDGER)}
          >
            View Report
          </primaryComponents.Button>
        </div>
        {data &&
          data?.map((item, index) => (
            <div key={index} className={styles.card}>
              <div style={{ textAlign: "left" }}>
                <div className={`${styles.title}`}>
                  <h6 className={"big-text-size"}>{item?.title}</h6>
                </div>
                <span className={"smallest-text-size"}>
                  {item?.description}
                </span>
                {item.deprecating && (
                  <div
                    style={{ marginTop: "10px", width: "100%" }}
                    className="error--squared"
                  >
                    <secondaryComponents.ToolTipV2 tipText={labelTootipText}>
                      <span className="ml-2">{labelIcon}</span>
                      Warning: This report is being deprecated
                    </secondaryComponents.ToolTipV2>
                  </div>
                )}
              </div>
              <primaryComponents.Button
                type="button"
                classNames={"btn btn--outline w-100"}
                onClick={() =>
                  navigate(pathConstants.ACCOUNTING_DETAILS({ id: item.id }))
                }
              >
                View Report
              </primaryComponents.Button>
            </div>
          ))}
      </div>
    </secondaryComponents.LoaderHelper>
  );
};

export default AccountingOverview;
